import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { Address, StringNumber } from '@ui/types/alias';
import { PossibleBigNumber } from '@ui/types/utility';
import BigNumber from 'bignumber.js';

export interface TpSlValueState {
  isLong: boolean | undefined;
  deltaPnl: number | undefined;
  pnlPercentage: number | undefined;
  priceValue: StringNumber;
  isPnlPercentage: boolean | undefined;
}

export interface PricesFactor {
  entryPrice: BigNumber | undefined;
  payTokenPrice: BigNumber | undefined;
}

export type OpenMarketTradeParams = {
  pairBase: `0x${string}`;
  amountIn: bigint;
  price: bigint;
  isLong: boolean;
  tokenIn: `0x${string}`;
  lvToken: `0x${string}`;
  qty: bigint;
  stopLoss: bigint;
  takeProfit: bigint;
  broker: number;
  value: bigint | undefined;
  pythUpdateData: Address[];
  oracleUpdateData: {
    pythPriceUpdateData: Address[];
    pythProPriceUpdateData: Address[];
  };
  extraFee: bigint;
};

export type Value = {
  usd: PossibleBigNumber;
  token: PossibleBigNumber;
};

export type MinInputLimitation = {
  minNotionalLimit: Value;
  min10Limit: Value;
  // standard100Limit: Value;
  // degen5000Limit: Value;
};

export type MaxInputLimitation = {
  leverageMarginNotionalMaxLimit: Value;
  maxInputMaxLongOILimit: Value;
  maxInputMaxShortOILimit: Value;
};

export enum EditTpSlType {
  POSITION = 'position',
  ORDER = 'order',
}

export type GenericTradeParams = {
  genericTradeParams: Pick<
    Position,
    | 'id'
    | 'collateralToken'
    | 'isMergedPosition'
    | 'takeProfit'
    | 'stopLoss'
    | 'pair'
    | 'getLeverage'
    | 'isLong'
    | 'getCollateralUsdBeforeOpenPositionFees'
    | 'entryPrice'
    | 'getTakeProfitDeltaPnl'
    | 'getTakeProfitPercentage'
    | 'getStopLossDeltaPnl'
    | 'getStopLossPercentage'
    | 'getMaxTpRatiosPrice'
    | 'getSizeUsd'
    | 'getLiquidationPrice'
    | 'getCollateralUsd'
    | 'size'
  >;
};
